import React from 'react';
import { Translation } from 'react-i18next';
import Resource from './Resource';
import { formatDate } from '../utils/format';

export default class PatientVisit extends Resource {
  constructor(properties: {}) {
    super(properties);
    this.properties.resource_type = 'patientVisit';
  }
  get institution_name() { // eslint-disable-line
    return null;
  }
  get title() {
    return <Translation ns='patientVisit'>{(t) => t('title', { date: this.dateText })}</Translation>;
  }
  get name(): String {
    return {
      text: (
        <Translation ns='patientVisit'>
          {(t) =>
            t('name',
              {
                institution: this.properties.institution_name,
                date: this.recordedAt ? formatDate(this.recordedAt) : ''
              })
          }
        </Translation>
      )
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/PatientVisit.js